import React from "react";
import Img from "gatsby-image";
import kebabCase from "lodash/kebabCase";
import snakeCase from "lodash/snakeCase";
import Link from "gatsby-link";


export default class Era extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
    };

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter() {
    this.setState({hovered: true});
  }

  handleMouseLeave() {
    this.setState({hovered: false});
  }

  render() {
    const {era: {fieldValue, totalCount}, data} = this.props;
    const {hovered} = this.state;

    const eraImageName = snakeCase(fieldValue).replace("_era", "");
    const eraImage = data[eraImageName]; // eslint-disable-line security/detect-object-injection

    const eraImagehover = data[`${eraImageName}_hover`];

    return (
      <div className="column is-one-third has-text-centered">
        <Link
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          to={`/tags/${kebabCase(fieldValue)}/`}
        >
          <figure className="image is-square">
            <Img
              sizes={eraImage.childImageSharp.sizes}
              className={hovered ? "era-hovered" : ""}
              outerWrapperClassName="era-image-outer-wrapper"
            />
            <Img
              sizes={eraImagehover.childImageSharp.sizes}
              outerWrapperClassName="era-image-outer-wrapper-hover"
            />
          </figure>
          <p className="is-size-5">
            {fieldValue.replace(/era/i, "")}            
          </p>
          <p className="subtitle is-6">
            {`(${totalCount} videos)`}
          </p>
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Eras/era.jsx